// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JoinRouteImport } from './routes/join'
import { Route as CreateRouteImport } from './routes/create'
import { Route as OnboardRouteRouteImport } from './routes/onboard/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as OauthSelectOrganizationRouteImport } from './routes/oauth/select-organization'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as BoardsBoardIdRouteImport } from './routes/boards.$boardId'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as JoinIndexRouteImport } from './routes/join.index'
import { Route as JoinBoardRouteImport } from './routes/join.board'
import { Route as OnboardIndexRouteImport } from './routes/onboard/index'
import { Route as OnboardWorkspaceRouteImport } from './routes/onboard/workspace'
import { Route as OnboardVerifyEmailRouteImport } from './routes/onboard/verify-email'
import { Route as OnboardUserRouteImport } from './routes/onboard/user'
import { Route as OnboardSampleRouteImport } from './routes/onboard/sample'
import { Route as OnboardInviteRouteImport } from './routes/onboard/invite'
import { Route as OnboardInvitationsRouteImport } from './routes/onboard/invitations'
import { Route as OnboardDoneRouteImport } from './routes/onboard/done'
import { Route as OnboardDatasourceRouteImport } from './routes/onboard/datasource'
import { Route as OnboardContactRouteImport } from './routes/onboard/contact'
import { Route as OnboardKeyTablesRouteRouteImport } from './routes/onboard/key-tables/route'
import { Route as OnboardCatalogRouteRouteImport } from './routes/onboard/catalog/route'
import { Route as OnboardBoardsRouteRouteImport } from './routes/onboard/boards/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppDatasetsRouteRouteImport } from './routes/_app/datasets/route'
import { Route as OnboardJoinIdRouteImport } from './routes/onboard/join.$id'
import { Route as OnboardJoinBoardIdRouteImport } from './routes/onboard/join-board.$id'
import { Route as OnboardKeyTablesIndexRouteImport } from './routes/onboard/key-tables/index'
import { Route as OnboardKeyTablesDatasourceIdRouteImport } from './routes/onboard/key-tables/$datasourceId'
import { Route as OnboardCatalogIndexRouteImport } from './routes/onboard/catalog/index'
import { Route as OnboardCatalogDatasourceIdRouteImport } from './routes/onboard/catalog/$datasourceId'
import { Route as OnboardBoardsIndexRouteImport } from './routes/onboard/boards/index'
import { Route as OnboardBoardsDatasourceIdRouteImport } from './routes/onboard/boards/$datasourceId'
import { Route as AppBoardsIndexRouteImport } from './routes/_app/boards/index'
import { Route as AppThreadThreadIdRouteImport } from './routes/_app/thread/$threadId'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsOrganizationRouteRouteImport } from './routes/_app/settings/_organization/route'
import { Route as AppDatasetsIndexRouteImport } from './routes/_app/datasets/index'
import { Route as AppDatasetsDatasetIdRouteImport } from './routes/_app/datasets/$datasetId'
import { Route as AppSettingsOrganizationPlansRouteImport } from './routes/_app/settings/_organization/plans'
import { Route as AppSettingsOrganizationOrganizationRouteImport } from './routes/_app/settings/_organization/organization'
import { Route as AppSettingsOrganizationMembersRouteImport } from './routes/_app/settings/_organization/members'
import { Route as AppSettingsOrganizationKnowledgeRouteImport } from './routes/_app/settings/_organization/knowledge'
import { Route as AppSettingsOrganizationExportRouteImport } from './routes/_app/settings/_organization/export'
import { Route as AppSettingsOrganizationApiKeysRouteImport } from './routes/_app/settings/_organization/api-keys'
import { Route as AppSettingsOrganizationDatasourcesIndexRouteImport } from './routes/_app/settings/_organization/datasources/index'
import { Route as AppSettingsOrganizationConnectionsIndexRouteImport } from './routes/_app/settings/_organization/connections/index'
import { Route as AppSettingsOrganizationDatasourcesDatasourceIdRouteImport } from './routes/_app/settings/_organization/datasources/$datasourceId'
import { Route as AppSettingsOrganizationConnectionsConnectionIdRouteImport } from './routes/_app/settings/_organization/connections/$connectionId'
import { Route as AppSettingsOrganizationDatasourcesNewIndexRouteImport } from './routes/_app/settings/_organization/datasources/new/index'
import { Route as AppSettingsOrganizationConnectionsNewIndexRouteImport } from './routes/_app/settings/_organization/connections/new/index'
import { Route as AppSettingsOrganizationConnectionsNewConnectionRouteRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/route'
import { Route as AppSettingsOrganizationConnectionsNewConnectionTriple_whaleRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/triple_whale'
import { Route as AppSettingsOrganizationConnectionsNewConnectionStripeRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/stripe'
import { Route as AppSettingsOrganizationConnectionsNewConnectionShopifyRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/shopify'
import { Route as AppSettingsOrganizationConnectionsNewConnectionSalesforceRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/salesforce'
import { Route as AppSettingsOrganizationConnectionsNewConnectionQuickbooksRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/quickbooks'
import { Route as AppSettingsOrganizationConnectionsNewConnectionPosthogRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/posthog'
import { Route as AppSettingsOrganizationConnectionsNewConnectionNetsuite_suiteanalyticsRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/netsuite_suiteanalytics'
import { Route as AppSettingsOrganizationConnectionsNewConnectionKlaviyoRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/klaviyo'
import { Route as AppSettingsOrganizationConnectionsNewConnectionHubspotRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/hubspot'
import { Route as AppSettingsOrganizationConnectionsNewConnectionGoogle_sheetsRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/google_sheets'
import { Route as AppSettingsOrganizationConnectionsNewConnectionGithubRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/github'
import { Route as AppSettingsOrganizationConnectionsNewConnectionFulfilRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/fulfil'
import { Route as AppSettingsOrganizationConnectionsNewConnectionFacebook_adsRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/facebook_ads'
import { Route as AppSettingsOrganizationConnectionsNewConnectionAttioRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/attio'
import { Route as AppSettingsOrganizationConnectionsNewConnectionAmazon_selling_partnerRouteImport } from './routes/_app/settings/_organization/connections/new/_connection/amazon_selling_partner'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const JoinRoute = JoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => rootRouteImport
          })
const CreateRoute = CreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => rootRouteImport
          })
const OnboardRouteRoute = OnboardRouteRouteImport.update({
            id: '/onboard',path: '/onboard',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const OauthSelectOrganizationRoute = OauthSelectOrganizationRouteImport.update({
            id: '/oauth/select-organization',path: '/oauth/select-organization',getParentRoute: () => rootRouteImport
          })
const OauthConsentRoute = OauthConsentRouteImport.update({
            id: '/oauth/consent',path: '/oauth/consent',getParentRoute: () => rootRouteImport
          })
const BoardsBoardIdRoute = BoardsBoardIdRouteImport.update({
            id: '/boards/$boardId',path: '/boards/$boardId',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const JoinIndexRoute = JoinIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => JoinRoute
          })
const JoinBoardRoute = JoinBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => JoinRoute
          })
const OnboardIndexRoute = OnboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OnboardRouteRoute
          })
const OnboardWorkspaceRoute = OnboardWorkspaceRouteImport.update({
            id: '/workspace',path: '/workspace',getParentRoute: () => OnboardRouteRoute
          })
const OnboardVerifyEmailRoute = OnboardVerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => OnboardRouteRoute
          })
const OnboardUserRoute = OnboardUserRouteImport.update({
            id: '/user',path: '/user',getParentRoute: () => OnboardRouteRoute
          })
const OnboardSampleRoute = OnboardSampleRouteImport.update({
            id: '/sample',path: '/sample',getParentRoute: () => OnboardRouteRoute
          })
const OnboardInviteRoute = OnboardInviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => OnboardRouteRoute
          })
const OnboardInvitationsRoute = OnboardInvitationsRouteImport.update({
            id: '/invitations',path: '/invitations',getParentRoute: () => OnboardRouteRoute
          })
const OnboardDoneRoute = OnboardDoneRouteImport.update({
            id: '/done',path: '/done',getParentRoute: () => OnboardRouteRoute
          })
const OnboardDatasourceRoute = OnboardDatasourceRouteImport.update({
            id: '/datasource',path: '/datasource',getParentRoute: () => OnboardRouteRoute
          })
const OnboardContactRoute = OnboardContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => OnboardRouteRoute
          })
const OnboardKeyTablesRouteRoute = OnboardKeyTablesRouteRouteImport.update({
            id: '/key-tables',path: '/key-tables',getParentRoute: () => OnboardRouteRoute
          })
const OnboardCatalogRouteRoute = OnboardCatalogRouteRouteImport.update({
            id: '/catalog',path: '/catalog',getParentRoute: () => OnboardRouteRoute
          })
const OnboardBoardsRouteRoute = OnboardBoardsRouteRouteImport.update({
            id: '/boards',path: '/boards',getParentRoute: () => OnboardRouteRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRouteRoute
          })
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRouteRoute
          })
const AppDatasetsRouteRoute = AppDatasetsRouteRouteImport.update({
            id: '/datasets',path: '/datasets',getParentRoute: () => AppRouteRoute
          })
const OnboardJoinIdRoute = OnboardJoinIdRouteImport.update({
            id: '/join/$id',path: '/join/$id',getParentRoute: () => OnboardRouteRoute
          })
const OnboardJoinBoardIdRoute = OnboardJoinBoardIdRouteImport.update({
            id: '/join-board/$id',path: '/join-board/$id',getParentRoute: () => OnboardRouteRoute
          })
const OnboardKeyTablesIndexRoute = OnboardKeyTablesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OnboardKeyTablesRouteRoute
          })
const OnboardKeyTablesDatasourceIdRoute = OnboardKeyTablesDatasourceIdRouteImport.update({
            id: '/$datasourceId',path: '/$datasourceId',getParentRoute: () => OnboardKeyTablesRouteRoute
          })
const OnboardCatalogIndexRoute = OnboardCatalogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OnboardCatalogRouteRoute
          })
const OnboardCatalogDatasourceIdRoute = OnboardCatalogDatasourceIdRouteImport.update({
            id: '/$datasourceId',path: '/$datasourceId',getParentRoute: () => OnboardCatalogRouteRoute
          })
const OnboardBoardsIndexRoute = OnboardBoardsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OnboardBoardsRouteRoute
          })
const OnboardBoardsDatasourceIdRoute = OnboardBoardsDatasourceIdRouteImport.update({
            id: '/$datasourceId',path: '/$datasourceId',getParentRoute: () => OnboardBoardsRouteRoute
          })
const AppBoardsIndexRoute = AppBoardsIndexRouteImport.update({
            id: '/boards/',path: '/boards/',getParentRoute: () => AppRouteRoute
          })
const AppThreadThreadIdRoute = AppThreadThreadIdRouteImport.update({
            id: '/thread/$threadId',path: '/thread/$threadId',getParentRoute: () => AppRouteRoute
          })
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppSettingsRouteRoute
          })
const AppSettingsOrganizationRouteRoute = AppSettingsOrganizationRouteRouteImport.update({
            id: '/_organization',getParentRoute: () => AppSettingsRouteRoute
          })
const AppDatasetsIndexRoute = AppDatasetsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDatasetsRouteRoute
          })
const AppDatasetsDatasetIdRoute = AppDatasetsDatasetIdRouteImport.update({
            id: '/$datasetId',path: '/$datasetId',getParentRoute: () => AppDatasetsRouteRoute
          })
const AppSettingsOrganizationPlansRoute = AppSettingsOrganizationPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationOrganizationRoute = AppSettingsOrganizationOrganizationRouteImport.update({
            id: '/organization',path: '/organization',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationMembersRoute = AppSettingsOrganizationMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationKnowledgeRoute = AppSettingsOrganizationKnowledgeRouteImport.update({
            id: '/knowledge',path: '/knowledge',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationExportRoute = AppSettingsOrganizationExportRouteImport.update({
            id: '/export',path: '/export',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationApiKeysRoute = AppSettingsOrganizationApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationDatasourcesIndexRoute = AppSettingsOrganizationDatasourcesIndexRouteImport.update({
            id: '/datasources/',path: '/datasources/',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationConnectionsIndexRoute = AppSettingsOrganizationConnectionsIndexRouteImport.update({
            id: '/connections/',path: '/connections/',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationDatasourcesDatasourceIdRoute = AppSettingsOrganizationDatasourcesDatasourceIdRouteImport.update({
            id: '/datasources/$datasourceId',path: '/datasources/$datasourceId',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationConnectionsConnectionIdRoute = AppSettingsOrganizationConnectionsConnectionIdRouteImport.update({
            id: '/connections/$connectionId',path: '/connections/$connectionId',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationDatasourcesNewIndexRoute = AppSettingsOrganizationDatasourcesNewIndexRouteImport.update({
            id: '/datasources/new/',path: '/datasources/new/',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationConnectionsNewIndexRoute = AppSettingsOrganizationConnectionsNewIndexRouteImport.update({
            id: '/connections/new/',path: '/connections/new/',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionRouteRoute = AppSettingsOrganizationConnectionsNewConnectionRouteRouteImport.update({
            id: '/connections/new/_connection',path: '/connections/new',getParentRoute: () => AppSettingsOrganizationRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionTriple_whaleRoute = AppSettingsOrganizationConnectionsNewConnectionTriple_whaleRouteImport.update({
            id: '/triple_whale',path: '/triple_whale',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionStripeRoute = AppSettingsOrganizationConnectionsNewConnectionStripeRouteImport.update({
            id: '/stripe',path: '/stripe',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionShopifyRoute = AppSettingsOrganizationConnectionsNewConnectionShopifyRouteImport.update({
            id: '/shopify',path: '/shopify',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionSalesforceRoute = AppSettingsOrganizationConnectionsNewConnectionSalesforceRouteImport.update({
            id: '/salesforce',path: '/salesforce',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionQuickbooksRoute = AppSettingsOrganizationConnectionsNewConnectionQuickbooksRouteImport.update({
            id: '/quickbooks',path: '/quickbooks',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionPosthogRoute = AppSettingsOrganizationConnectionsNewConnectionPosthogRouteImport.update({
            id: '/posthog',path: '/posthog',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionNetsuite_suiteanalyticsRoute = AppSettingsOrganizationConnectionsNewConnectionNetsuite_suiteanalyticsRouteImport.update({
            id: '/netsuite_suiteanalytics',path: '/netsuite_suiteanalytics',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionKlaviyoRoute = AppSettingsOrganizationConnectionsNewConnectionKlaviyoRouteImport.update({
            id: '/klaviyo',path: '/klaviyo',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionHubspotRoute = AppSettingsOrganizationConnectionsNewConnectionHubspotRouteImport.update({
            id: '/hubspot',path: '/hubspot',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionGoogle_sheetsRoute = AppSettingsOrganizationConnectionsNewConnectionGoogle_sheetsRouteImport.update({
            id: '/google_sheets',path: '/google_sheets',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionGithubRoute = AppSettingsOrganizationConnectionsNewConnectionGithubRouteImport.update({
            id: '/github',path: '/github',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionFulfilRoute = AppSettingsOrganizationConnectionsNewConnectionFulfilRouteImport.update({
            id: '/fulfil',path: '/fulfil',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionFacebook_adsRoute = AppSettingsOrganizationConnectionsNewConnectionFacebook_adsRouteImport.update({
            id: '/facebook_ads',path: '/facebook_ads',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionAttioRoute = AppSettingsOrganizationConnectionsNewConnectionAttioRouteImport.update({
            id: '/attio',path: '/attio',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })
const AppSettingsOrganizationConnectionsNewConnectionAmazon_selling_partnerRoute = AppSettingsOrganizationConnectionsNewConnectionAmazon_selling_partnerRouteImport.update({
            id: '/amazon_selling_partner',path: '/amazon_selling_partner',getParentRoute: () => AppSettingsOrganizationConnectionsNewConnectionRouteRoute
          })





const AppDatasetsRouteRouteChildren = {
  AppDatasetsDatasetIdRoute: AppDatasetsDatasetIdRoute,AppDatasetsIndexRoute: AppDatasetsIndexRoute
}

const AppDatasetsRouteRouteWithChildren = AppDatasetsRouteRoute._addFileChildren(AppDatasetsRouteRouteChildren)




const AppSettingsOrganizationConnectionsNewConnectionRouteRouteChildren = {
  AppSettingsOrganizationConnectionsNewConnectionAmazon_selling_partnerRoute: AppSettingsOrganizationConnectionsNewConnectionAmazon_selling_partnerRoute,AppSettingsOrganizationConnectionsNewConnectionAttioRoute: AppSettingsOrganizationConnectionsNewConnectionAttioRoute,AppSettingsOrganizationConnectionsNewConnectionFacebook_adsRoute: AppSettingsOrganizationConnectionsNewConnectionFacebook_adsRoute,AppSettingsOrganizationConnectionsNewConnectionFulfilRoute: AppSettingsOrganizationConnectionsNewConnectionFulfilRoute,AppSettingsOrganizationConnectionsNewConnectionGithubRoute: AppSettingsOrganizationConnectionsNewConnectionGithubRoute,AppSettingsOrganizationConnectionsNewConnectionGoogle_sheetsRoute: AppSettingsOrganizationConnectionsNewConnectionGoogle_sheetsRoute,AppSettingsOrganizationConnectionsNewConnectionHubspotRoute: AppSettingsOrganizationConnectionsNewConnectionHubspotRoute,AppSettingsOrganizationConnectionsNewConnectionKlaviyoRoute: AppSettingsOrganizationConnectionsNewConnectionKlaviyoRoute,AppSettingsOrganizationConnectionsNewConnectionNetsuite_suiteanalyticsRoute: AppSettingsOrganizationConnectionsNewConnectionNetsuite_suiteanalyticsRoute,AppSettingsOrganizationConnectionsNewConnectionPosthogRoute: AppSettingsOrganizationConnectionsNewConnectionPosthogRoute,AppSettingsOrganizationConnectionsNewConnectionQuickbooksRoute: AppSettingsOrganizationConnectionsNewConnectionQuickbooksRoute,AppSettingsOrganizationConnectionsNewConnectionSalesforceRoute: AppSettingsOrganizationConnectionsNewConnectionSalesforceRoute,AppSettingsOrganizationConnectionsNewConnectionShopifyRoute: AppSettingsOrganizationConnectionsNewConnectionShopifyRoute,AppSettingsOrganizationConnectionsNewConnectionStripeRoute: AppSettingsOrganizationConnectionsNewConnectionStripeRoute,AppSettingsOrganizationConnectionsNewConnectionTriple_whaleRoute: AppSettingsOrganizationConnectionsNewConnectionTriple_whaleRoute
}

const AppSettingsOrganizationConnectionsNewConnectionRouteRouteWithChildren = AppSettingsOrganizationConnectionsNewConnectionRouteRoute._addFileChildren(AppSettingsOrganizationConnectionsNewConnectionRouteRouteChildren)



const AppSettingsOrganizationRouteRouteChildren = {
  AppSettingsOrganizationApiKeysRoute: AppSettingsOrganizationApiKeysRoute,AppSettingsOrganizationExportRoute: AppSettingsOrganizationExportRoute,AppSettingsOrganizationKnowledgeRoute: AppSettingsOrganizationKnowledgeRoute,AppSettingsOrganizationMembersRoute: AppSettingsOrganizationMembersRoute,AppSettingsOrganizationOrganizationRoute: AppSettingsOrganizationOrganizationRoute,AppSettingsOrganizationPlansRoute: AppSettingsOrganizationPlansRoute,AppSettingsOrganizationConnectionsConnectionIdRoute: AppSettingsOrganizationConnectionsConnectionIdRoute,AppSettingsOrganizationDatasourcesDatasourceIdRoute: AppSettingsOrganizationDatasourcesDatasourceIdRoute,AppSettingsOrganizationConnectionsIndexRoute: AppSettingsOrganizationConnectionsIndexRoute,AppSettingsOrganizationDatasourcesIndexRoute: AppSettingsOrganizationDatasourcesIndexRoute,AppSettingsOrganizationConnectionsNewConnectionRouteRoute: AppSettingsOrganizationConnectionsNewConnectionRouteRouteWithChildren,AppSettingsOrganizationConnectionsNewIndexRoute: AppSettingsOrganizationConnectionsNewIndexRoute,AppSettingsOrganizationDatasourcesNewIndexRoute: AppSettingsOrganizationDatasourcesNewIndexRoute
}

const AppSettingsOrganizationRouteRouteWithChildren = AppSettingsOrganizationRouteRoute._addFileChildren(AppSettingsOrganizationRouteRouteChildren)



const AppSettingsRouteRouteChildren = {
  AppSettingsOrganizationRouteRoute: AppSettingsOrganizationRouteRouteWithChildren,AppSettingsIndexRoute: AppSettingsIndexRoute
}

const AppSettingsRouteRouteWithChildren = AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)



const AppRouteRouteChildren = {
  AppDatasetsRouteRoute: AppDatasetsRouteRouteWithChildren,AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,AppIndexRoute: AppIndexRoute,AppThreadThreadIdRoute: AppThreadThreadIdRoute,AppBoardsIndexRoute: AppBoardsIndexRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const OnboardBoardsRouteRouteChildren = {
  OnboardBoardsDatasourceIdRoute: OnboardBoardsDatasourceIdRoute,OnboardBoardsIndexRoute: OnboardBoardsIndexRoute
}

const OnboardBoardsRouteRouteWithChildren = OnboardBoardsRouteRoute._addFileChildren(OnboardBoardsRouteRouteChildren)




const OnboardCatalogRouteRouteChildren = {
  OnboardCatalogDatasourceIdRoute: OnboardCatalogDatasourceIdRoute,OnboardCatalogIndexRoute: OnboardCatalogIndexRoute
}

const OnboardCatalogRouteRouteWithChildren = OnboardCatalogRouteRoute._addFileChildren(OnboardCatalogRouteRouteChildren)




const OnboardKeyTablesRouteRouteChildren = {
  OnboardKeyTablesDatasourceIdRoute: OnboardKeyTablesDatasourceIdRoute,OnboardKeyTablesIndexRoute: OnboardKeyTablesIndexRoute
}

const OnboardKeyTablesRouteRouteWithChildren = OnboardKeyTablesRouteRoute._addFileChildren(OnboardKeyTablesRouteRouteChildren)



const OnboardRouteRouteChildren = {
  OnboardBoardsRouteRoute: OnboardBoardsRouteRouteWithChildren,OnboardCatalogRouteRoute: OnboardCatalogRouteRouteWithChildren,OnboardKeyTablesRouteRoute: OnboardKeyTablesRouteRouteWithChildren,OnboardContactRoute: OnboardContactRoute,OnboardDatasourceRoute: OnboardDatasourceRoute,OnboardDoneRoute: OnboardDoneRoute,OnboardInvitationsRoute: OnboardInvitationsRoute,OnboardInviteRoute: OnboardInviteRoute,OnboardSampleRoute: OnboardSampleRoute,OnboardUserRoute: OnboardUserRoute,OnboardVerifyEmailRoute: OnboardVerifyEmailRoute,OnboardWorkspaceRoute: OnboardWorkspaceRoute,OnboardIndexRoute: OnboardIndexRoute,OnboardJoinBoardIdRoute: OnboardJoinBoardIdRoute,OnboardJoinIdRoute: OnboardJoinIdRoute
}

const OnboardRouteRouteWithChildren = OnboardRouteRoute._addFileChildren(OnboardRouteRouteChildren)




const JoinRouteChildren = {
  JoinBoardRoute: JoinBoardRoute,JoinIndexRoute: JoinIndexRoute
}

const JoinRouteWithChildren = JoinRoute._addFileChildren(JoinRouteChildren)

const rootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,OnboardRouteRoute: OnboardRouteRouteWithChildren,CreateRoute: CreateRoute,JoinRoute: JoinRouteWithChildren,LoginRoute: LoginRoute,LogoutRoute: LogoutRoute,SignupRoute: SignupRoute,VerifyEmailRoute: VerifyEmailRoute,AuthCallbackRoute: AuthCallbackRoute,BoardsBoardIdRoute: BoardsBoardIdRoute,OauthConsentRoute: OauthConsentRoute,OauthSelectOrganizationRoute: OauthSelectOrganizationRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)